import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach bearer token (persisted in localStorage) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const OPPORTUNITY_COLORS = {
  BUY: { bg: "#EFE6D8", text: "#B35C2E", border: "#D8C4B0" },
  ADOPT: { bg: "#EAF0E6", text: "#3E5733", border: "#BED2B5" },
  VISIT: { bg: "#FAF1E4", text: "#A6761F", border: "#EDD8B6" },
  LEARN: { bg: "#F2ECE4", text: "#5C4636", border: "#DACFBE" },
  VOLUNTEER: { bg: "#F5ECE6", text: "#A35427", border: "#E5C8B8" },
  SUPPORT: { bg: "#EBF2EC", text: "#47673A", border: "#B9D1BA" },
  PROJECT: { bg: "#ECEFF2", text: "#4A5A66", border: "#C7D2D9" },
};

